import request from '@/common/request'

class RotinaService {
  getAll() {
    return request.get('/rotinas')
  }
}

export default new RotinaService()
